import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthProvider";

export function ProtectedRoute({ allowPasswordChange = false }) {
    const { status } = useAdminAuth();
    const location = useLocation();

    if (status === "checking") {
        return (
            <div
                data-testid="admin-loading"
                className="min-h-screen flex items-center justify-center bg-ink text-neutral-400"
            >
                <div className="animate-pulse">Chargement…</div>
            </div>
        );
    }
    if (status === "unauthenticated") {
        return (
            <Navigate
                to="/admin/login"
                replace
                state={{ from: location.pathname }}
            />
        );
    }
    if (status === "must_change_password" && !allowPasswordChange) {
        return <Navigate to="/admin/change-password" replace />;
    }
    return <Outlet />;
}
